import { z } from "zod";

export const dbEnvSchema = z.object({
	DB_HOST: z.string().describe("MySQL host for explorer database"),
	DB_PORT: z.coerce
		.number()
		.default(3306)
		.describe("MySQL port for explorer database"),
	DB_USER: z.string().describe("MySQL user for explorer database"),
	DB_PASSWORD: z.string().describe("MySQL password for explorer database"),
	DB_NAME: z.string().describe("MySQL database name for explorer"),
});

export const apiDbEnvSchema = z.object({
	API_DB_HOST: z.string().describe("MySQL host for API database"),
	API_DB_PORT: z.coerce
		.number()
		.default(3306)
		.describe("MySQL port for API database"),
	API_DB_USER: z.string().describe("MySQL user for API database"),
	API_DB_PASSWORD: z.string().describe("MySQL password for API database"),
	API_DB_NAME: z.string().describe("MySQL database name for API"),
});

export const clickHouseEnvSchema = z.object({
	CLICK_HOUSE_URL: z.string().describe("ClickHouse server URL"),
	CLICK_HOUSE_USERNAME: z.string().describe("ClickHouse username"),
	CLICK_HOUSE_PASSWORD: z.string().describe("ClickHouse password"),
});

export const envSchema = dbEnvSchema
	.extend(apiDbEnvSchema.shape)
	.extend(clickHouseEnvSchema.shape);

/** @public Used by the repository-level environment metadata generator. */
export const envExamples: Record<keyof z.infer<typeof envSchema>, string> = {
	DB_HOST: "localhost",
	DB_PORT: "3306",
	DB_USER: "USER",
	DB_PASSWORD: "PASSWORD",
	DB_NAME: "one-click",
	API_DB_HOST: "localhost",
	API_DB_PORT: "3306",
	API_DB_USER: "USER",
	API_DB_PASSWORD: "PASSWORD",
	API_DB_NAME: "one-click",
	CLICK_HOUSE_URL: "https://example.clickhouse.cloud:8443",
	CLICK_HOUSE_USERNAME: "explorer_user",
	CLICK_HOUSE_PASSWORD: "PASSWORD",
};

export type Env = z.infer<typeof envSchema>;
